module.exports = __webpack_public_path__ + "img/wordqhuan.a9ed9d2d.svg";